import { heroStat, siteMeta, tickerItems } from "@/mocks/crash";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex flex-col justify-end min-h-[640px] lg:min-h-[720px] overflow-hidden bg-ink-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20wide%20still%20of%20a%20grand%20ornate%20mirror%20shattered%20into%20fractures%20with%20warm%20amber%20and%20coral%20light%20pouring%20through%20the%20cracks%2C%20floating%20glassy%20shards%20and%20fine%20dust%2C%20deep%20dark%20charcoal%20background%2C%20dramatic%20rim%20lighting%2C%20high%20contrast%2C%20moody%20stylized%20concept%20art&width=1600&height=900&seq=hero-crash-x1&orientation=landscape"
          alt="碎掉的完美镜像，暖色光芒从裂缝中透出，象征女神人设崩塌的幻灭现场"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/70 via-ink-950/45 to-ink-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-ink-950/70 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-8 pt-32 pb-0">
        <div className="max-w-6xl mx-auto">
          <p className="rise inline-flex items-center gap-2 rounded-full bg-paper-50/10 border border-paper-50/20 px-4 py-1.5 text-paper-50/90 text-sm">
            <span className="ticker-chip w-2 h-2 rounded-full bg-coral-400"></span>
            全网吃瓜专题 · 持续更新中
            <span className="hidden sm:inline text-paper-50/50">— DISILLUSION LAB</span>
          </p>

          <h1 className="rise mt-6 max-w-3xl font-display text-4xl sm:text-5xl md:text-6xl leading-[1.08] text-paper-50">
            当「完美」开始裂缝，
            <br />
            <span className="text-coral-400">女神塌房</span>是一次滤镜的集体幻灭
          </h1>

          <p className="rise mt-6 max-w-2xl text-paper-50/85 text-base md:text-lg leading-relaxed">
            清纯甜妹、学霸才女、完美伴侣……聚光灯下被层层包装的完美形象，
            为何总在某个深夜轰然倒塌？我们从铸房、裂缝到崩塌，带你一次看透
            <strong className="text-paper-50 font-semibold">人设崩塌</strong>背后的真实机制，
            理性吃瓜，不再被完美主义绑架。
          </p>

          <div className="rise mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#events"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-coral-500 hover:bg-coral-600 text-white font-semibold px-7 py-3.5 transition-colors"
            >
              围观最新塌房现场
              <i className="ri-fire-fill"></i>
            </a>
            <a
              href="#types"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-paper-50/30 hover:bg-white/10 text-paper-50 font-medium px-7 py-3.5 transition-colors"
            >
              查看人设档案
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-px bg-paper-50/15 rounded-2xl overflow-hidden border border-paper-50/15">
            {heroStat.map((s) => (
              <div key={s.label} className="bg-ink-950/40 backdrop-blur px-5 py-5">
                <p className="font-display text-2xl md:text-3xl text-paper-50">{s.num}</p>
                <p className="mt-1 text-xs text-paper-50/65 tracking-wide">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 mt-10 border-t border-paper-50/10 bg-ink-950/55 backdrop-blur overflow-hidden">
        <div className="flex marquee-track w-max items-center gap-8 py-3.5 px-4">
          {[...tickerItems, ...tickerItems].map((t, i) => (
            <span key={i} className="inline-flex items-center gap-3 whitespace-nowrap text-paper-50/75 text-sm">
              <i className="ri-flashlight-fill text-coral-400 text-sm"></i>
              {t}
              <i className="ri-fire-fill text-paper-50/30"></i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}